module.exports = __webpack_public_path__ + "static/f7530a51fc66ab369f9eb579be3d9dc548ffe3ba6db2d51b59db0c59b7b41a19-7ca112d6ceccbc43cce3aba4c2ce4f79.jpeg";